/*
  Create Your Piece — step 01 · Sport (10.02).
  A native radio group (Tab enters once, arrows move, Enter continues).
  Sports with no pieces in their collection are not offered. Each tile shows
  the sport's lead piece photographed on white (Paper 10.32).
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  CYP.use(function (cyp) {
    var panel = cyp.root.querySelector('[data-pb-step="1"]');
    var tiles = panel.querySelectorAll('[data-sport-tile]');
    var next = panel.querySelector('[data-sport-next]');

    tiles.forEach(function (tile) {
      var sp = cyp.sportBy(tile.getAttribute('data-sport-tile'));
      if (!sp || !sp.pieces.length) { tile.hidden = true; return; }
      var media = tile.querySelector('[data-sport-media]');
      var src = cyp.leadImage(sp);
      if (media && src) {
        var im = document.createElement('img');
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        im.src = cyp.sized(src, 500);
        media.appendChild(im);
      }
    });

    function render() {
      var s = cyp.state;
      tiles.forEach(function (tile) {
        var input = tile.querySelector('input');
        input.checked = input.value === s.sport;
        tile.classList.toggle('is-selected', input.checked);
      });
      panel.classList.toggle('has-choice', !!s.sport);
      next.setAttribute('aria-disabled', s.sport ? 'false' : 'true');
    }

    function commit() {
      if (!cyp.state.sport) return;
      cyp.track('sport_selected', { sport: cyp.state.sport });
      cyp.go('2');
    }

    panel.addEventListener('change', function (e) {
      if (e.target.name !== 'pb-sport') return;
      cyp.set({ sport: e.target.value });
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.name === 'pb-sport') { e.preventDefault(); commit(); }
    });
    next.addEventListener('click', commit);

    cyp.on('state', render);
  });
})();
